import { Components, Theme } from '@mui/material/styles';
import { ThemeBranding } from '../types';

export const createTableCellTheme = (settings: ThemeBranding): Components<Theme>['MuiTableCell'] => ({
  styleOverrides: {
    head: ({ theme }) => ({
      backgroundColor: settings.primaryTableHeaderColor,
      color: theme.palette.getContrastText(settings.primaryTableHeaderColor),
    }),
  },
});
